<template>
    <LoadingScreen v-if="isLoading" :percentage="percentage" />
    <div v-else>
        <div v-if="!inPage" class="header text-light">
            <div class="header__wrapper container-fluid container-xl">
                <div class="header__wrap-logo">
                    <div class="header__logo">
                        <router-link to="/" class="header__logo-link" exact>
                            <img
                                height="60"
                                width="94"
                                class="header__logo-image"
                                :src="require('@/assets/images/logo.svg')"
                                alt="debet Logo"
                            />
                        </router-link>
                    </div>
                </div>
                <div class="header__wrap-action">
                    <div class="header__lucky d-none d-lg-block">
                         <div class="header__lucky-inner">
                             <div class="header__lucky-icon">
                                 <img src="@/assets/images/thantai.png" alt="">
                             </div>
                            <div class="header__lucky-number">
                                {{ luckyNumber }}
                            </div>
                            <div class="header__lucky-text"> THẦN TÀI CHO SỐ
                            </div>
                        </div>
                    </div>
                    <div class="vl d-none d-lg-block"></div>
                    <div v-if="isLoggedIn" class="header__user-info">
                        <div class="header__history">
                            <router-link
                                :to="{ name: 'history' }"
                                class="btn header__btn-history d-flex align-content-center"
                                active-class="header__btn-history--active"
                            >
                                <span class="d-none d-lg-inline-block">
                                    LỊCH SỬ CƯỢC
                                </span>
                                <span class="d-inline-block d-lg-none">
                                    LỊCH SỬ
                                </span>
                            </router-link>
                        </div>
                        <div class="vl"></div>
                        <div class="header__user">
                            <a
                                :href="`${clientUrl}/?action=user/deposit`"
                                class="btn"
                                :title="userData.fullname"
                            >
                                <div
                                    class="header__avatar d-none d-lg-block"
                                ></div>
                                <div class="header__user-information">
                                    <div class="header__user-name">
                                        {{ userData.fullname }}
                                    </div>
                                    <div class="header__user-balance">
                                        <span
                                            class="header__current-balance"
                                        >
                                            {{
                                                (userData.balance /
                                                    clientBalanceUnit)
                                                    | currency
                                            }}
                                        </span>
                                        <span class="header__currency">
                                            &nbsp;{{ clientCurrencyCode }}
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="vl d-none d-lg-block"></div>
                        <div class="header__recharge d-none d-lg-block">
                            <a
                                :href="`${clientUrl}/?action=user/deposit `"
                                class="btn bg-primary header__btn-recharge text-dark"
                            >
                                <span>NẠP TIỀN</span>
                            </a>
                        </div>
                    </div>
                    <div v-if="!isLoggedIn" class="header__guest">
                        <div class="header__login" @click="handleLogin">
                            <a
                                :href="`${clientUrl}?action=login`"
                                class="btn bg-primary header__btn-login font-weight-bold"
                            >
                                ĐĂNG NHẬP
                            </a>
                        </div>
                        <div class="vl d-none d-lg-block"></div>
                        <div class="header__register" @click="handleRegister">
                            <a
                                :href="`${clientUrl}?action=register`"
                                class="btn bg-primary header__btn-register font-weight-bold"
                            >
                                ĐĂNG KÝ
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import LoadingScreen from '@/components/common/LoadingScreen/LoadingScreen';
import betMixin from '@/mixins/bet.mixin';
import { REGION } from '@/utils/urlParams';

export default {
    components: {
        LoadingScreen,
    },
    mixins: [betMixin],
    data() {
        return {
            clientUrl: process.env.VUE_APP_CLIENT_URL,
            luckyNumber: 0,
            clientCurrencyCode: process.env.VUE_APP_CLIENT_CURRENCY_CODE,
            clientBalanceUnit: process.env.VUE_APP_CLIENT_BALANCE_UNIT,
            isLoading: true,
            percentage: 0,
        };
    },
    methods: {
        ...mapActions({
            fetchUser: 'userModule/fetchUser',
        }),
        getLuckyNumber(size = 2) {
            const maxNum = parseInt(''.padStart(size, '9'));
            const username = this.userData.fullname
                ? this.userData.fullname.toString()
                : 'Guest';
            const id = username
                .split('')
                .map(char => char.charCodeAt(0))
                .reduce((current, previous) => previous + current);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            let num = id + today.getTime();
            num %= maxNum;
            return num.toString().padStart(2, '0');
        },
        handleLogin() {
            this.storeBetIfNotLogin(this.betData);
        },
        handleRegister() {
            this.storeBetIfNotLogin(this.betData);
        },
        checkIfReBet() {
            const reBet = localStorage.getItem('reBet');
            if (reBet) {
                this.$swal
                    .fire({
                        title: '<div class="popup__icon popup__icon--rebet">',
                        html:
                            'Bạn có phiếu cược chưa hoàn thành.<br/>Bạn có muốn tải lại thông tin phiếu cược không?',
                        showCancelButton: true,
                        reverseButtons: true,
                        customClass: {
                            popup: 'swal2-popup-warning-custom',
                        },
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Hủy',
                        showCloseButton: true,
                    })
                    .then(result => {
                        localStorage.removeItem('reBet');
                        if (result.isConfirmed) {
                            this.handleReBet(JSON.parse(reBet));
                        }
                    });
            }
        },
        handleReBet(reBetData) {
            const regionKey = this.getKeyByValue(
                REGION.VI,
                reBetData.city.region,
            );
            this.$router
                .push({
                    name: REGION.EN[regionKey],
                    params: { reBet: reBetData },
                })
                .catch(() => {});
        },
        getKeyByValue(object, value) {
            return Object.keys(object).find(key => object[key] === value);
        },
    },
    async created() {
        this.checkIfReBet();
        this.luckyNumber = this.getLuckyNumber();

        if (this.token) {
            await this.fetchUser({
                onDownloadProgress: progressEvent => {
                    const total = parseFloat(progressEvent.total);
                    const current = progressEvent.loaded;
                    let percentCompleted = Math.floor((current / total) * 100);
                    setTimeout(function() {}, 2000);
                    this.percentage = percentCompleted;
                },
            });
        } else {
            this.percentage = 99;
        }
        this.isLoading = false;
    },
    computed: {
        ...mapGetters({
            token: 'userModule/token',
            inPage: 'userModule/inPage',
            userData: 'userModule/user',
            isLoggedIn: 'userModule/isLoggedIn',
            betData: 'betModule/betData',
        }),
    },
};
</script>

<style scoped lang="scss">
@import './Header';
</style>
